export default "__VITE_ASSET__ec902bf4__"